<!--<button class="debugToggleBtn" cue-button (click)="useVirtualScroll.set(!useVirtualScroll())">enable/disable virtual scroll feature</button>-->
<div
  class="inner-content flex flex-col target-height overflow-hidden"
  [class.half-width]="showNavigationFilter() || isKioskMode()"
>
  <assist-textbox
    data-cy="target-search-input"
    [showClear]="true"
    [placeholder]="targetResourceName() || (translation.navigation.placeholderResourceList | transloco)"
    [formControl]="search"
    [iconBefore]="ICONS.cueSearch"
  />

  <div class="flex flex-row overflow-hidden gap-3 grow">
    <div class="h-full flex flex-col overflow-auto flex-1">
      @if (resourceListDataSource.isLoading()) {
        <cue-loading />
      }
      <!--          <div style="position: absolute; left: 20px; top: 200px; z-index: 999999999; background-color: orange">-->
      <!--            AAA {{resourceListDataSource.hasValue()}}-->
      <!--            {{resourceListDataSource.value() | json}}-->
      <!--          </div>-->
      @if (resourceListDataSource.hasValue()) {
        @if (resourceListDataSource.value()?.total === 0) {
          <div class="not-found">
            <p class="m-0 py-3">
              {{ translation.notFound.resourceNotFound | transloco }}
            </p>
          </div>
        }

        @if (resourceListDataSource.value()?.total !== 0) {
          <div class="location-table grow h-full">
            <div class="fade-border flex overflow-hidden w-full grow">
              <div class="flex gap-2 flex-col overflow-auto w-full">
                @if (useVirtualScroll()) {
                  <cdk-virtual-scroll-viewport
                    class="grow *:pt-7 scrollbar-thick"
                    cueDynamicScrollSize
                    [itemSize]="search?.value ? 120 : 100"
                    minBufferPx="50"
                    maxBufferPx="100"
                  >
                    <ng-container
                      *cdkVirtualFor="let item of resourceListDataSource.value(); index as i; let last = last"
                    >
                      <div class="cdk-scroll-item" [class.has-search-result]="search?.value">
                        @if (i === 0) {
                          <div [id]="'startPosition'"></div>
                        }

                        @if (item) {
                          <div class="relative item-wrapper">
                            @if (i > 0) {
                              <hr class="divider-hr" />
                            }

                            <div
                              class="item"
                              [class.selected]="
                                (item.resourceId && item.resourceId === targetResourceId()) ||
                                (item.qrCodes?.length === 1 && item.qrCodes[0].qrCodeId === targetQrCodeId())
                              "
                              (click)="navigate(item, $event, false)"
                            >
                              <cue-resource-event-detail
                                [item]="item"
                                [categories]="categories.value()"
                                (requestNavigate)="navigate(item, $event, false)"
                              >
                              </cue-resource-event-detail>

                              @if (search?.value) {
                                <div class="search-result">
                                  <span class="label">{{ translation.wayfinding.searched | transloco }}: </span>
                                  <span class="search-result-items">
                                    @for (
                                      searchResultItem of item | searchResult: search?.value;
                                      track searchResultItem
                                    ) {
                                      <span class="search-result-item"
                                        >{{ searchResultItem }}<span class="separator">, </span>
                                      </span>
                                    }
                                  </span>
                                </div>
                              }
                            </div>

                            @if ((item.qrCodes | canShowPois) && this.overlaysIds().includes(item.resourceId)) {
                              <div
                                (click)="removeOverlay(item.resourceId)"
                                class="appear z-10 absolute inset-0 !bg-white !bg-opacity-80 backdrop-blur-[2px] grid justify-items-center content-center"
                              >
                                <button
                                  size="small"
                                  cue-button
                                  [link]="true"
                                  class="!underline !truncate"
                                  (click)="navigate(item, $event, false)"
                                  [innerHTML]="
                                    (item.displayNameForApp | localizedString) ?? (item.name | localizedString)
                                  "
                                ></button>
                                <div class="flex flex-wrap gap-y-1 gap-x-1 justify-center">
                                  @for (
                                    qrCode of item.qrCodes | poiBoolean: 'showInStartList';
                                    track qrCode;
                                    let last = $last
                                  ) {
                                    <div
                                      class="flex gap-x-1"
                                      [class.selected-item]="qrCode.qrCodeId === targetQrCodeId()"
                                    >
                                      @if (!qrCode.notNavigationPoint) {
                                        <button
                                          size="tiny"
                                          cue-button
                                          [link]="true"
                                          class="!underline !truncate"
                                          (click)="navigateToSpecificQR(item, qrCode.qrCodeId, $event)"
                                        >
                                          <cue-icon [icon]="ICONS.cueQrCode" />
                                          @if ((qrCode.name | localizedString).length <= 15) {
                                            {{ qrCode.name | localizedString }}
                                          } @else {
                                            {{ qrCode.name | localizedString | slice: 0 : 15 }}
                                            <span>...</span>
                                          }
                                        </button>
                                      }
                                      @if (!last) {
                                        <div class="mt-2 inline-block h-4 bg-[--background-divider] w-[1px]"></div>
                                      }
                                    </div>
                                  }
                                </div>
                              </div>
                            }
                          </div>
                        } @else {
                          <img src="assets/images/loading.png" width="30" height="30" />
                        }
                      </div>
                    </ng-container>
                  </cdk-virtual-scroll-viewport>
                } @else if (resourceList.hasValue()) {
                  @for (item of resourceList.value()?.data; track item; let i = $index; let last = $last) {
                    <div class="cdk-scroll-item" [class.has-search-result]="search?.value">
                      @if (i === 0) {
                        <div [id]="'startPosition'"></div>
                      }

                      @if (item) {
                        <div class="relative item-wrapper">
                          @if (i > 0) {
                            <hr class="divider-hr" />
                          }
                          <div
                            class="item"
                            [class.selected]="
                              (item.resourceId && item.resourceId === targetResourceId()) ||
                              (item.qrCodes?.length === 1 && item.qrCodes[0].qrCodeId === targetQrCodeId())
                            "
                            (click)="navigate(item, $event, false)"
                          >
                            <cue-resource-event-detail
                              [item]="item"
                              [categories]="categories.value()"
                              (requestNavigate)="navigate(item, $event, false)"
                            >
                            </cue-resource-event-detail>

                            @if (search?.value) {
                              <div class="search-result" [class.show]="true">
                                <span class="label">{{ translation.wayfinding.searched | transloco }}: </span>
                                <span class="search-result-items">
                                  @for (
                                    searchResultItem of item | searchResult: search?.value;
                                    track searchResultItem
                                  ) {
                                    <span class="search-result-item"
                                      >{{ searchResultItem }}<span class="separator">, </span>
                                    </span>
                                  }
                                </span>
                              </div>
                            }
                          </div>

                          @if ((item.qrCodes | canShowPois) && this.overlaysIds().includes(item.resourceId)) {
                            <div
                              (click)="removeOverlay(item.resourceId)"
                              class="appear z-10 absolute inset-0 !bg-white !bg-opacity-80 backdrop-blur-[2px] grid justify-items-center content-center"
                            >
                              <button
                                size="small"
                                cue-button
                                [link]="true"
                                class="!underline !truncate"
                                (click)="navigate(item, $event, false)"
                                [innerHTML]="
                                  (item.displayNameForApp | localizedString) ?? (item.name | localizedString)
                                "
                              ></button>
                              <div class="flex flex-wrap gap-y-1 gap-x-1 justify-center">
                                @for (
                                  qrCode of item.qrCodes | poiBoolean: 'showInStartList';
                                  track qrCode;
                                  let last = $last
                                ) {
                                  <div
                                    class="flex gap-x-1"
                                    [class.selected-item]="qrCode.qrCodeId === targetQrCodeId()"
                                  >
                                    @if (!qrCode.notNavigationPoint) {
                                      <button
                                        size="tiny"
                                        cue-button
                                        [link]="true"
                                        class="!underline !truncate"
                                        (click)="navigateToSpecificQR(item, qrCode.qrCodeId, $event)"
                                      >
                                        <cue-icon [icon]="ICONS.cueQrCode" />
                                        @if ((qrCode.name | localizedString).length <= 15) {
                                          {{ qrCode.name | localizedString }}
                                        } @else {
                                          {{ qrCode.name | localizedString | slice: 0 : 15 }}
                                          <span>...</span>
                                        }
                                      </button>
                                    }
                                    @if (!last) {
                                      <div class="mt-2 inline-block h-4 bg-[--background-divider] w-[1px]"></div>
                                    }
                                  </div>
                                }
                              </div>
                            </div>
                          }
                        </div>
                      } @else {
                        <img src="assets/images/loading.png" width="30" height="30" />
                      }
                    </div>
                  }
                }
              </div>
            </div>
          </div>
        }
      }
    </div>
  </div>
</div>
@if (showNavigationFilter()) {
  <div class="assist-target-filter-wrapper">
    <cue-start-target-filter
      [selectedResourceTypeIdList]="selectedResourceTypeIdList()"
      [selectedCategoryIdList]="selectedCategoryIdList()"
      [selectedAreaIdList]="selectedAreaIdList()"
      [availableCategoryList]="categories.value()"
      [availableAreaList]="availableAreaList() | areaToHierarchy"
      (requestClose)="changeShowFilter(false)"
      (confirmFilter)="updateData($event)"
      [isKioskMode]="isKioskMode()"
    />
  </div>
}
